
export function unmask (maskedValue, mask) {
  const defaultTokens = ['#', 'X', 'S', 'A', 'a', '!']
  let unmaskedValue = ''
  let isToken

  for (let i = 0; i < maskedValue.length; i++) {
    isToken = false
    for (let j = 0; j < defaultTokens.length; j++) {
      if (mask[i] === defaultTokens[j]) {
        isToken = true
      }
    }

    if (isToken) {
      unmaskedValue += maskedValue[i]
    }
  }

  return unmaskedValue
}

export const importer = {
  url: (url) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = url
      script.addEventListener('load', () => resolve(script), false)
      script.addEventListener('error', () => reject(script), false)
      document.body.appendChild(script)
    })
  },
  urls: (urls) => {
    return Promise.all(urls.map(importer.url))
  }
}

export const parseCurrency = function (currency) {
  return Number(currency.replace(/[^0-9.-]+/g, ''))
}
